import { Components } from "@thisgorilla/primate-ds";

import { useTheme } from "styled-components";
import { FlexRowCenter, FlexRowSpaced } from "../../../../Common/Styles";
import { PodsProps } from "./Pods";

export const TitleAndButton = ({
  isOpen,
  setIsOpen,
}: PodsProps.TitleAndButtonProps) => {
  const { typography } = useTheme();

  return (
    <FlexRowSpaced>
      <FlexRowCenter>
        <Components.Icon type="Grid" size="16px" />
        <Components.Text
          text={"Pods"}
          style={{ tokenStyle: typography.Heading.S }}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-400"
        />
      </FlexRowCenter>
      <Components.IconButton
        iconType={isOpen ? "ChevronUp" : "ChevronDown"}
        size="XS"
        kind="Secondary"
        disabled={false}
        onClick={() => setIsOpen(!isOpen)}
      />
    </FlexRowSpaced>
  );
};
